import { Action } from 'redux';

import { IExperimentResult, IExperimentList } from '@models';
import { ErrorDetails } from '@utils';

import { IActionString } from '../common';

export interface IExperimentListsState {
  experimentLists: IExperimentList[];
}

export const SELECTED_EXPERIMENTS_FILE = 'SELECTED_EXPERIMENTS_FILE';
export const VALIDATING_EXPERIMENTS_FILE = 'VALIDATING_EXPERIMENTS_FILE';
export const EXPERIMENTS_FILE_VALIDATION_SUCCEEDED =
  'EXPERIMENTS_FILE_VALIDATION_SUCCEEDED';
export const EXPERIMENTS_FILE_VALIDATION_FAILED =
  'EXPERIMENTS_FILE_VALIDATION_FAILED';
export const DISCARD_EXPERIMENT_LIST = 'DISCARD_EXPERIMENT_LIST';
export const CLEAR_EXPERIMENT_LIST = 'CLEAR_EXPERIMENT_LIST';
export const START_UPLOAD = 'START_UPLOAD';
export const START_UPLOAD_FAILED = 'START_UPLOAD_FAILED';
export const START_UPLOAD_COMPLETED = 'START_UPLOAD_COMPLETED';

export interface ISelectedExperimentsFileAction extends Action {
  payload: {
    id: string;
    file: File;
  };
}

export interface IExperimentListValidationSucceededAction extends Action {
  payload: {
    id: string;
    results: IExperimentResult;
  };
}

export interface IExperimentListValidationFailedAction extends Action {
  payload: {
    id: string;
    errors: ErrorDetails[];
  };
}

export type ExperimentListActionTypes =
  | IActionString
  | IExperimentListValidationSucceededAction
  | IExperimentListValidationFailedAction
  | ISelectedExperimentsFileAction;
